<div class="setting-container">
    <div class="tab-set">
        <tam-tab-set [selectedIndex]="currentTab" (selectChange)="selectTabChange($event)">
            <tam-tab *ngFor="let item of tabData;" [title]="item.title" [editable]="item.editable">
            </tam-tab>
        </tam-tab-set>
    </div>
    <div class="tab-content" [ngClass]="{'auto-overflow':currentTab===3}">
        <router-outlet></router-outlet>
        <!-- <email-digest-list *ngIf="currentTab===0"></email-digest-list>
        <tam-flat-file-management *ngIf="currentTab===1"></tam-flat-file-management>
        <tam-manage-screens *ngIf="currentTab===2"></tam-manage-screens>
        <advanced-setting *ngIf="currentTab===3"></advanced-setting>
        <tam-admin-page-layout *ngIf="currentTab===4"></tam-admin-page-layout> -->
    </div>
</div>